import PageNotFound404 from "./404";
export default PageNotFound404;
